var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Input, checkIsPlatform, getTestId } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { validateFieldStateHandler, validateFieldValueHandler } from '../../ContactDetailFormWidgetUtils';
export var InputFormField = props => {
  var _a, _b, _c;
  var testID = props.testID,
    fieldId = props.fieldId,
    onChangeTextMetaData = props.onChangeTextMetaData,
    onValidInputMetaData = props.onValidInputMetaData,
    onInValidInputMetaData = props.onInValidInputMetaData,
    onPressInMetaData = props.onPressInMetaData,
    onFieldValidityChangeHandler = props.onFieldValidityChangeHandler,
    setFormFieldDataHandler = props.setFormFieldDataHandler,
    onUserAction = props.onUserAction,
    restProps = __rest(props, ["testID", "fieldId", "onChangeTextMetaData", "onValidInputMetaData", "onInValidInputMetaData", "onPressInMetaData", "onFieldValidityChangeHandler", "setFormFieldDataHandler", "onUserAction"]);
  var _useState = useState((_a = restProps === null || restProps === void 0 ? void 0 : restProps.hintText) !== null && _a !== void 0 ? _a : ''),
    hintText = _useState[0],
    setHintText = _useState[1];
  var _useState2 = useState((_b = restProps === null || restProps === void 0 ? void 0 : restProps.value) !== null && _b !== void 0 ? _b : ''),
    fieldValue = _useState2[0],
    setFieldValue = _useState2[1];
  var isExternalValidRef = useRef();
  var fieldStateRef = useRef((_c = restProps === null || restProps === void 0 ? void 0 : restProps.state) !== null && _c !== void 0 ? _c : 'none');
  useEffect(() => {
    if (restProps === null || restProps === void 0 ? void 0 : restProps.value) {
      var isValid = validateFieldValueHandler(restProps, restProps === null || restProps === void 0 ? void 0 : restProps.value, fieldStateRef.current);
      if (isValid) {
        onValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id: fieldId
        }, onValidInputMetaData), {
          value: restProps === null || restProps === void 0 ? void 0 : restProps.value
        }));
      } else {
        onInValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id: fieldId
        }, onInValidInputMetaData), {
          value: restProps === null || restProps === void 0 ? void 0 : restProps.value
        }));
      }
    }
  }, []);
  useEffect(() => {
    checkFieldValidity();
  }, [restProps === null || restProps === void 0 ? void 0 : restProps.isExternalValid]);
  useEffect(() => {
    var _a;
    fieldStateRef.current = (_a = restProps === null || restProps === void 0 ? void 0 : restProps.state) !== null && _a !== void 0 ? _a : 'none';
    setHintText(restProps === null || restProps === void 0 ? void 0 : restProps.hintText);
  }, [restProps === null || restProps === void 0 ? void 0 : restProps.state, restProps === null || restProps === void 0 ? void 0 : restProps.hintText]);
  var checkFieldValidity = () => {
    isExternalValidRef.current = restProps === null || restProps === void 0 ? void 0 : restProps.isExternalValid;
    var isValid = validateFieldStateHandler(restProps, isExternalValidRef.current, fieldStateRef.current) && validateFieldValueHandler(restProps, fieldValue, fieldStateRef.current);
    onFieldValidityChangeHandler === null || onFieldValidityChangeHandler === void 0 ? void 0 : onFieldValidityChangeHandler(fieldId, isValid);
  };
  var onPressInCallback = () => {
    onPressInMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldId
    }, onPressInMetaData), Object.assign({}, restProps)));
  };
  var onValidInputCallback = value => {
    var isValid = validateFieldStateHandler(restProps, isExternalValidRef.current, fieldStateRef.current);
    onFieldValidityChangeHandler === null || onFieldValidityChangeHandler === void 0 ? void 0 : onFieldValidityChangeHandler(fieldId, isValid);
    onValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldId
    }, onValidInputMetaData), Object.assign(Object.assign({}, restProps), {
      value
    })));
  };
  var onInValidInputCallback = value => {
    if (restProps === null || restProps === void 0 ? void 0 : restProps.isExternalValidityRequired) {
      isExternalValidRef.current = false;
    }
    onFieldValidityChangeHandler === null || onFieldValidityChangeHandler === void 0 ? void 0 : onFieldValidityChangeHandler(fieldId, false);
    onInValidInputMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldId
    }, onInValidInputMetaData), Object.assign(Object.assign({}, restProps), {
      value
    })));
  };
  var onChangeTextCallback = value => {
    setFieldValue(value);
    if (fieldStateRef.current == 'error') {
      fieldStateRef.current = 'none';
      setHintText('');
    }
    setFormFieldDataHandler === null || setFormFieldDataHandler === void 0 ? void 0 : setFormFieldDataHandler(fieldId, value);
    if (value == '') {
      var isValid = validateFieldStateHandler(restProps, isExternalValidRef.current, fieldStateRef.current) && validateFieldValueHandler(restProps, value, fieldStateRef.current);
      onFieldValidityChangeHandler === null || onFieldValidityChangeHandler === void 0 ? void 0 : onFieldValidityChangeHandler(fieldId, isValid);
    }
    onChangeTextMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldId
    }, onChangeTextMetaData), Object.assign(Object.assign({}, restProps), {
      value
    })));
  };
  return _jsx(Input, Object.assign({}, getTestId(testID, fieldId), restProps, {
    state: fieldStateRef.current,
    hintText: hintText,
    hintTextAccessibilityProps: restProps === null || restProps === void 0 ? void 0 : restProps.hintTextAccessibilityProps,
    onChangeText: onChangeTextCallback,
    onValidInput: onValidInputCallback,
    onInValidInput: onInValidInputCallback
  }, checkIsPlatform('web') ? {
    onClick: onPressInCallback
  } : {
    onPressIn: onPressInCallback
  }, restProps === null || restProps === void 0 ? void 0 : restProps.accessibilityProps));
};